import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLegalLinks } from '@jwp/ott-hooks-react/src/useLegalLinks';
import { useAppConfig } from '@jwp/ott-hooks-react/src/useAppConfig';
import Arrow from '../../../../theme/assets/icons/right_arrow.svg';

import { useTheme } from '../../../../../ThemeContext';

import styles from './Legal.module.scss';

type Props = {
  panelClassName?: string;
  panelHeaderClassName?: string;
};

const Legal = ({ panelClassName, panelHeaderClassName }: Props): JSX.Element => {
  const { t } = useTranslation('user');
  const { universalStyles } = useTheme();
  const { canShowLegal } = useAppConfig();
  const { accountLegalLinks } = useLegalLinks();

  return (
    <section className={panelClassName}>
      <div className={panelHeaderClassName}>
        <h2>{t('nav.legal')}</h2>
        <div className={styles.legalContainer}>
          {accountLegalLinks.map((link) => {
            const labelKey = canShowLegal && link.labelKey === 'privacy_policy' ? 'privacy_statement' : link.labelKey;
            const label = t(`legal.${labelKey}`);

            return (
              <a key={link.key} href={link.url} target="_blank" rel="noopener noreferrer" className={styles.legalRow} style={universalStyles.leftSideBarText}>
                <span className={styles.legalLabel}>{label}</span>
                <span className={styles.arrowIcon}>
                  <img src={Arrow} className={styles.icon} alt="" />
                </span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Legal;
